import { useEffect, useLayoutEffect } from 'react';

export const useSafeEffect = typeof window !== 'undefined' && !process.env.TEST_SSR ? useLayoutEffect : useEffect;
